import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { BehaviorSubject } from 'rxjs';

import { NHAPipesModule } from '@nha/pipes';
import { CURRENT_APPLICATION, IPortalLink } from '@nha/api/core';

import { NHAUserProfileMenuModule } from '@nha/components/user-profile-menu';
import { NHAApplicationContainerComponent } from './application-container.component';
import { ApplicationComponentResolverService } from './services';
import { NHAAppLauncherModule } from '../app-launcher/app-launcher.module';
import { ComponentLoaderService } from '@nha/services';
import { MaintenanceNotificationComponent } from '../maintenence-notification/maintenance-notification.component';

/** setup the current application portal link for injection */
export const currentNHAApplication$: BehaviorSubject<IPortalLink> = new BehaviorSubject<IPortalLink>(null);

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		MatButtonModule,
		MatChipsModule,
		MatIconModule,
		MatTabsModule,
		NHAUserProfileMenuModule,
		NHAPipesModule,
		NHAAppLauncherModule,
		MaintenanceNotificationComponent,
		NHAApplicationContainerComponent
	],
	providers: [],
	exports: [NHAApplicationContainerComponent]
})
export class NHAApplicationContainerModule {
	static forRoot(): ModuleWithProviders<NHAApplicationContainerModule> {
		return {
			ngModule: NHAApplicationContainerModule,
			providers: [ComponentLoaderService, ApplicationComponentResolverService, { provide: CURRENT_APPLICATION, useValue: currentNHAApplication$ }]
		};
	}
}

// TODO: deprecate and remove the ApplicationComponentResolverService in favor of the component loader
